jQuery(document).ready(function($){
	$('#prod_search').keyup( function(){
		search();
	});
	
	function search(){
	    var input, filter, ul, li, sku, i, title;
	    input = $("#prod_search");
	    filter = input.val().toUpperCase();
	    ul = $("#prod_list");
	    li = ul.find("li");
	    
	    // if the input has a value
	    if(filter == '') {
	    	ul.hide();
        	return false;
        }else{
        	//loop through li and search for a match 
        	for(i = 0; i < li.length; i++){
		        title = li[i].getElementsByTagName("p")[0];

		        if(title.innerHTML.toUpperCase().indexOf(filter) > -1){
		        	ul.show();
		            li[i].style.display = "block";
		        }else{
		            li[i].style.display = "none";
		        }
		    }
        }
	        
	    
	}
});

// jQuery(document).ready(function($){
// 	shop_hero();

// 	$(window).on('hashchange', function(e){
// 	 alert('hello');
// 	});

	// $('.berocket_single_filter_widget_17100 input').click(function(){
	// 	// shop_hero();
	// 	alert('hello');
	// });
	// if( $('#shop_hero').length ){
	// 	// alert('ih');
	// 	var txt_cont = $(this).find('h1');
	// 	var widget_input = $('.berocket_single_filter_widget_17100 input');
		

	// 	$(widget_input).each(function(){
	// 		var cur = $(this);
	// 		var widget_txt = $('.berocket_single_filter_widget_17100 label');
	// 		console.log(widget_txt);

	// 		if( cur.is(':checked') ){
	// 			alert(cur.html());
	// 		}
	// 	});
	// }
// 	function shop_hero(){
// 		var pathname = window.location.href; 
// 		var split = pathname.split('type-of-light[')[1].split(']');
// 		// alert(split[0]);

// 		switch(split[0]){
// 			case 'ceiling-lights':
// 				$('#shop_hero h1').html('Ceiling Lights');
// 				break;
// 			case 'table-and-floor':
// 				$('#shop_hero h1').html('Table and Floor Lights');
// 				break;
// 			case 'wall-lights':
// 				$('#shop_hero h1').html('Wall Lights');
// 				break;
// 			case 'accessories':
// 				$('#shop_hero h1').html('Accessories');
// 				break;
// 		}
// 	} 
// });